var _rect, _rect2, _rect3, _rect4, _rect5, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg95(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 9,
    fill: "#DA291C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 31,
    height: 20,
    rx: 2.6,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 31,
    height: 4,
    fill: "#DA291C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 23.5,
    width: 7.5,
    height: 4.6,
    rx: 1,
    fill: "#DA291C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 25.2,
    width: 12.5,
    height: 2.2,
    rx: 1.1,
    fill: "#DA291C",
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 23.5,
    y: 43,
    textAnchor: "middle",
    fontFamily: "Arial,Helvetica,sans-serif",
    fontSize: 9,
    fontWeight: 800,
    fill: "#fff"
  }, "GEL")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg95);
export default __webpack_public_path__ + "static/media/95.9d62ed0589a9164f83da7f1588ffd239.svg";
export { ForwardRef as ReactComponent };